import { render, staticRenderFns } from "./pages2B.vue?vue&type=template&id=6e87149a&scoped=true&"
import script from "./pages2B.vue?vue&type=script&lang=js&"
export * from "./pages2B.vue?vue&type=script&lang=js&"
import style0 from "./pages2B.vue?vue&type=style&index=0&id=6e87149a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87149a",
  null
  
)

export default component.exports